import {get, set} from "local-storage";
import {TimeQuery, TimeRange} from "helpers/api/generateUrl";
import {DEFAULT_PAGINATION} from "helpers/constants/Pagination";
import {PaginationQuery} from "helpers/interfaces/Pagination";
import {Sorting} from "helpers/interfaces/Sorting";
import {rangeToInterval} from "shared/input/DateRangeSelect";

//TODO(Keune): Save pagination, sorting and time per Patient

function savePagination(key: string, pagination: PaginationQuery) {
  if (key === undefined) {
    return;
  }
  set(buildStoreKey("Pagination", key, "perPage"), pagination.perPage);
  set(buildStoreKey("Pagination", key, "page"), pagination.page);
}

function saveSorting(key: string, sorting: Sorting) {
  if (key === undefined) {
    return;
  }
  set(buildStoreKey("Sorting", key, "order"), sorting.order);
  set(buildStoreKey("Sorting", key, "sort"), sorting.sort);
}

function saveTime(key: string, range: TimeQuery["range"]) {
  if (key === undefined || !range || range === "custom") {
    return;
  }
  set(buildStoreKey("Time", key, "range"), range);
}

function getPagination(key: string): PaginationQuery {
  const perPage = get<number>(buildStoreKey("Pagination", key, "perPage"));
  const page = get<number>(buildStoreKey("Pagination", key, "page"));

  return {
    perPage: perPage ?? DEFAULT_PAGINATION.perPage,
    page: page ?? DEFAULT_PAGINATION.page
  };
}

function getSorting(key: string, initialSorting?: Sorting): Sorting {
  const order = get<string>(buildStoreKey("Sorting", key, "order"));
  const sort = get<Sorting["sort"]>(buildStoreKey("Sorting", key, "sort"));

  return {
    order: order ?? initialSorting?.order,
    sort: sort ?? initialSorting?.sort
  };
}

function getTime(key: string, initialTime?: TimeQuery): TimeQuery {
  const range = get<TimeRange>(buildStoreKey("Time", key, "range"));

  return {
    range: range ?? initialTime?.range,
    ...rangeToInterval(range ?? initialTime?.range)
  };
}

function buildStoreKey(prefix: string, key: string, attributeName: string): string {
  return [prefix, key, attributeName].join("_");
}

export {
  getPagination,
  getSorting,
  getTime,
  savePagination,
  saveSorting,
  saveTime
};
